import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

export const Loader = (props) =>{
    return(
        <>
            <Modal
                open={props.loading}
                //onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={props.style}>
                <Typography id="modal-modal-description" sx={{ mt: 2, mb:5 }} textAlign="center">
                    <CircularProgress sx={{ fontSize: 60 }} color="success" />
                    </Typography>
                    <Typography id="modal-modal-title" variant="h6" component="h2" alignItems="center" textAlign="center"sx={{ mt: 2, mb:3 }}>
                        Submitting your payment..
                    </Typography>  
                </Box>
        </Modal>
        </>
    )
}
